/*
 * DrawerButton Messages
 *
 * This contains all the text for the DrawerButton component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  openMenu: {
    id: 'app.components.DrawerButton.openMenu',
    defaultMessage: 'Open Menu',
  },
});
